import React from 'react';
import Form from "./Form";

const Ru = () => {
    return (
        <div className="info-pages-main-content">
            <div className="info-page-inner-content price-list">
                <h4>Инструкция для удаления данных:</h4>
                <p>Если Вы хотите удалить
                    свои данные с <a
                        href="https://ifurn.pro/" className="" target={'_blank'}> iFurn.pro</a>, сообщите пожалуйста свои
                    контактные данные для
                    удаления и причину.</p>
            </div>
            <Form/>

        </div>
    );
};

export default Ru;